import React, { useEffect, useContext, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import "../../styles/globals.css";
import "./ResetPasswordPage.css";
import { Form, Input } from "antd";
import { ExclamationCircleOutlined, WarningFilled } from "@ant-design/icons";
import { validateEmail } from "../../utils/validationUtils";
import { showToast } from "../../utils/commonUtils";
import {
  sendCertificationNumberMailWhenPasswordReset,
  sendCertificationNumberMailWhenPasswordResetBeforeLogin,
} from "../../services/service";

/**
 * パスワード再設定の登録メール入力画面用のコンポーネント
 * @param {} なし
 * @return {} なし
 */
function ResetPasswordPage() {
  useEffect(() => {
    setEmailCheck(false);
  }, []);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const { setGlobalEmailAddress, globalAccessToken } = useContext(AppContext);
  const [errors, setErrors] = useState({
    email: false,
  });
  const [emailCheck, setEmailCheck] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const [modeObject, setModeObject] = useState({
    prevLabel: "",
    prevPath: "",
    nextPath: "",
  });

  const emailInput = useRef(null);

  useEffect(() => {
    const newModeObject = {};
    if (location.pathname?.includes("reset-password")) {
      newModeObject.prevLabel = "ログインページに戻る";
      newModeObject.prevPath = "/account-login";
      newModeObject.nextPath = "/reset-password/certificatrion-number-input";
    }
    if (location.pathname?.includes("mypage/password-setting")) {
      newModeObject.prevLabel = "マイページに戻る";
      newModeObject.prevPath = "/mypage/menu";
      newModeObject.nextPath =
        "/mypage/password-setting/certificatrion-number-input";
    }
    setModeObject(newModeObject);
  }, [location.pathname]);

  useEffect(() => {
    emailInput.current.input.focus();
  }, [errors?.email]);

  /**
   * 値変更時の処理
   * @param {string} fieldName - フィールド名
   */
  const onValueChange = async (fieldName) => {
    try {
      await form.validateFields([fieldName]);
      setErrors({ ...errors, [fieldName]: false });
      setErrorMessage(null);
      setEmailCheck(true);
    } catch (error) {
      setErrors({ ...errors, [fieldName]: true });
      setEmailCheck(false);
    }
  };

  //送信ボタンを押したときの処理
  const handleCheckEmailRegistClick = async (path) => {
    await form.validateFields({
      validateOnly: true,
    });
    const values = form.getFieldsValue();
    const { email } = values;
    setGlobalEmailAddress(values.email);

    try {
      let data = "";
      if (location.pathname?.includes("mypage/password-setting")) {
        //ログイン後
        data = await sendCertificationNumberMailWhenPasswordReset(
          globalAccessToken,
          email
        );
      } else {
        //ログイン前
        data = await sendCertificationNumberMailWhenPasswordResetBeforeLogin(
          email
        );
      }
      if (data.result.status === "OK") {
        // 認証番号入力画面に遷移
        navigate(path);
        showToast("認証番号メールを送付しました", "success");
      } else {
        setErrorMessage(data?.result?.error_message);
      }
    } catch (error) {
      showToast("メールの送信に失敗しました", "error");
      console.error(
        "Error sendCertificationNumberMailWhenPasswordReset:",
        error
      );
    }
  };

  // 戻るボタンを押したときの処理
  const handleBackClick = (path) => {
    navigate(path);
  };

  return (
    <div className="reset-password">
      <div className="main-area">
        <div className="title">パスワード再設定</div>
        <div className="detail">
          パスワード再設定用メールを送信しますので、ご登録いただいているメールアドレスを入力し、
          「送信」ボタンをクリックしてください。
        </div>
        <div className="form">
          <Form
            form={form}
            name="reset-password"
            layout="vertical"
            initialValues={{ remember: true }}
          >
            <Form.Item
              className="ant-label"
              label="メールアドレス"
              name="email"
              rules={[
                { required: true, message: "メールアドレスを入力してください" },
                { validator: validateEmail },
              ]}
              validateTrigger="onChange"
            >
              <Input
                className="ant-input"
                placeholder="例)example@example.com"
                suffix={errors.email ? <ExclamationCircleOutlined /> : null}
                ref={emailInput}
                onChange={() => {
                  onValueChange("email");
                }}
              />
            </Form.Item>
            {errorMessage && (
              <div className="error-area">
                <div className="icon-area">
                  <WarningFilled className="icon" />
                </div>
                <label>{errorMessage}</label>
              </div>
            )}
          </Form>

          <div className="general-buttons">
            <GeneralButton
              buttonLabel={"送信"}
              type={
                Object.values(errors).some((error) => error || !emailCheck)
                  ? "disabled"
                  : "primary-blue"
              }
              onClick={() => handleCheckEmailRegistClick(modeObject.nextPath)}
            />
            <GeneralButton
              buttonLabel={modeObject.prevLabel}
              type={"secondary-white"}
              onClick={() => handleBackClick(modeObject.prevPath)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default ResetPasswordPage;
